import { useState, useContext, useEffect, useRef } from "react";
import axios from "axios";
import { Store } from "@store";
import { getCount } from "@utils/metrics/countMetric";
import { upvoteCommunity, removeUpvoteCommunity, getUpvotingStatus } from "@queries/community.queries";
import styles from "@styles/community/upvoteDialog.module.css";
import { getUUID } from "@utils/device";
import ListModal from "@components/modal/ListModal";
import UpvotersList from "./UpvotersList";
import UtsavModal from "src/globalModule/components/UtsavModal";
import { useRouter } from "next/router";
import BlockedUserModal from "@components/modal/BlockedUserModal";
import { HTTP_STATUS_CODES } from "@utils/constants";
import GuestUserModal from "src/globalModule/components/guestUserModal";
export default function UpvoteDialog({
  communityID,
  communityTypeID,
  isAdmin,
  smallScreen = false,
  upvotedStatus,
  upvoteNo,
  isUpvoting
}) {
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const [isUpvotingOn, setIsUpvotingOn] = useState(false);
  const router = useRouter();
  const [data, setData] = useState(null);
  const [upvotes, setUpvotes] = useState(upvoteNo);
  // const [isUpvoted, setIsUpvoted] = useState(
  //   upvotedStatus ? upvotedStatus : false
  // );
  const [isUpvoted, setIsUpvoted] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const upvoteBtn = useRef(null);
  const [openRemoveUpvoteModal, setopenRemoveUpvoteModal] = useState(false);
  const [openUpvotersList, setOpenUpvotersList] = useState(false);
  const [viewUpvotes, setViewUpvotes] = useState(false);

  //const [openUnauthorizedModal, setOpenUnauthorizedModal] = useState(false);
  // const handleOpenUnauthorizedModal = () => {
  //   setOpenUnauthorizedModal(!openUnauthorizedModal);
  // };
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [openBlockedUserModal, setOpenBlockedUserModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const toggleBlockedServiceModal = () => {
    setOpenBlockedUserModal(!openBlockedUserModal);
  };
  useEffect(() => {
    async function getStatus(token) {
      const res = await getUpvotingStatus({
        cancelToken: token,
        typeID: communityTypeID
      });
      if (res?.upvoting && res?.communityTypeID === communityTypeID && isUpvoting) {
        //if (res?.upvoting) {
        setData(res);
        setIsUpvotingOn(true);
        if (res?.endTime < Date.now()) {
          setViewUpvotes(true);
        }
      } else {
        setIsUpvotingOn(false);
      }
    }
    const source = axios.CancelToken.source();
    getStatus(source.token);
    setIsUpvoted(upvotedStatus);
    setUpvotes(upvoteNo);
    return () => {
      source.cancel();
    };
  }, [communityID, communityTypeID]);
  async function onClickHandler() {
    if (loggedInUser.accessToken == null) {
      //setOpenUnauthorizedModal(true);
      setLoginModalOpen(true);
      return () => {};
    }
    setDisabled(true);
    if (isUpvoted) {
      setIsUpvoted(false);
      setUpvotes(cur => cur - 1);
      await removeUpvoteCommunity({
        communityID: communityID,
        accessToken: loggedInUser.accessToken
      });
    } else {
      setIsUpvoted(true);
      setUpvotes(cur => cur + 1);
      const res = await upvoteCommunity({
        communityID: communityID,
        upvoterUid: loggedInUser.uid,
        deviceID: getUUID(),
        accessToken: loggedInUser.accessToken,
        ts: Date.now()
      });
      if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
        setErrorMsg(res.message);
        toggleBlockedServiceModal();
        return () => {};
      }
    }
    setDisabled(false);
    if (openRemoveUpvoteModal) {
      setopenRemoveUpvoteModal(cur => !cur);
    }
  }
  const toggleRemoveUpvoteModal = async () => {
    setopenRemoveUpvoteModal(cur => !cur);
  };
  function viewUpvote(event) {
    if (upvotes <= 0) return () => {};
    if (upvoteBtn.current !== event.target && !upvoteBtn.current?.contains(event.target)) {
      setOpenUpvotersList(true);
    }
  }
  if (isUpvotingOn && data) {
    return <>
        <div className={smallScreen ? styles.upvote_sm : styles.upvote_left} onClick={isAdmin ? null : viewUpvote}>
          <div className={styles.upvote_dialog}>
            <div className={styles.title_upvote}>
              <h5>{data.eventName}</h5>
            </div>

            <p className={styles.text}>
              {upvotes > 0 ? getCount(upvotes) : ""}
              <span>
                {upvotes > 0 ? upvotes === 1 ? " Upvote" : " Upvotes" : ""}
                {!isUpvoted && upvotes > 0 && !isAdmin && " | "}
                {isUpvoted || isAdmin || viewUpvotes ? "" : "Vote Now !!"}
              </span>
            </p>

            <div className={styles.upvote_dialog_inner}>
              {isAdmin || viewUpvotes ? <>
                  <button className={`btn ${styles.upvote_btn}`} onClick={() => setOpenUpvotersList(true)}>
                    View Upvotes
                  </button>
                </> : <>
                  {isUpvoted ? <button className={`${styles.upvoted_btn}`}
              // onClick={onClickHandler}
              disabled={disabled} ref={upvoteBtn} onClick={toggleRemoveUpvoteModal}>
                      Upvoted
                    </button> : <button className={`${styles.upvote_btn}`} onClick={onClickHandler} disabled={disabled} ref={upvoteBtn}>
                      Upvote
                    </button>}
                </>}
            </div>
          </div>
        </div>

        <ListModal show={openUpvotersList} heading="Upvoters" setShowList={setOpenUpvotersList}>
          <UpvotersList communityID={communityID} />
        </ListModal>
        
        {isLoginModalOpen && <GuestUserModal isLoginModalOpen={isLoginModalOpen} setLoginModalOpen={setLoginModalOpen} />}

        {openRemoveUpvoteModal && <UtsavModal open={openRemoveUpvoteModal} toggleModal={toggleRemoveUpvoteModal} heading="Confirm Remove Upvote" message="Are you sure want to Remove Upvote?" acceptMsg="Yes, Remove" onAccept={onClickHandler} rejectMsg="Cancel" positive={false} />}
        {openBlockedUserModal && <BlockedUserModal open={openBlockedUserModal} toggleModal={toggleBlockedServiceModal} message={errorMsg} acceptMsg="Contact Utsav" rejectMsg="Cancel" positive={true} />}
      </>;
  } else return "";
}